import {
  DlqMessageHeader,
  DlqMessage,
  ApproveMessageRequest,
  SubmitNewMessageRequest,
  MessageOverride
} from '@gms/monitoring-api';
import { Action } from '@ngrx/store';
import { SortDescriptor } from '@progress/kendo-data-query';

export enum DlqActionTypes {
  FETCH_DLQ_MESSAGES = '[DLQ] Get DLQ Messages',
  FETCH_DLQ_MESSAGES_SUCCESS = '[DLQ] Get DLQ Messages Success',
  FETCH_DLQ_MESSAGES_FAILURE = '[DLQ] Get DLQ Messages Failure',
  FETCH_DLQ_MESSAGE_BY_ID = '[DLQ] Get DLQ Message By Id',
  FETCH_DLQ_MESSAGE_BY_ID_SUCCESS = '[DLQ] Get DLQ Message By Id Success',
  FETCH_DLQ_MESSAGE_BY_ID_FAILURE = '[DLQ] Get DLQ Message By Id Failure',
  DELETE_DLQ_MESSAGE_BY_ID = '[DLQ] Delete DLQ Message By Id',
  DELETE_DLQ_MESSAGE_BY_ID_SUCCESS = '[DLQ] Delete DLQ Message By Id Success',
  DELETE_DLQ_MESSAGE_BY_ID_FAILURE = '[DLQ] Delete DLQ Message By Id Failure',
  REDRIVE_DLQ_MESSAGE_BY_ID = '[DLQ] Redrive DLQ Message By Id',
  REDRIVE_DLQ_MESSAGE_BY_ID_SUCCESS = '[DLQ] Redrive DLQ Message By Id Success',
  REDRIVE_DLQ_MESSAGE_BY_ID_FAILURE = '[DLQ] Redrive DLQ Message By Id Failure',
  APPROVE_DLQ_MESSAGE = '[DLQ] Approve DLQ Message',
  APPROVE_DLQ_MESSAGE_SUCCESS = '[DLQ] Approve DLQ Message Success',
  APPROVE_DLQ_MESSAGE_FAILURE = '[DLQ] Approve DLQ Message Failure',
  SUBMIT_NEW_DLQ_MESSAGE = '[DLQ] Submit New DLQ Message',
  SUBMIT_NEW_DLQ_MESSAGE_SUCCESS = '[DLQ] Submit New DLQ Message Success',
  SUBMIT_NEW_DLQ_MESSAGE_FAILURE = '[DLQ] Submit New DLQ Message Failure',
  SUBMIT_MESSAGE_FOR_REVIEW = '[DLQ] Submit Message For Review',
  SUBMIT_MESSAGE_FOR_REVIEW_SUCCESS = '[DLQ] Submit Message For Review Success',
  SUBMIT_MESSAGE_FOR_REVIEW_FAILURE = '[DLQ] Submit Message For Review Failure',
  DELETE_MULTIPLE_DLQ_MESSAGES = '[DLQ] Delete Multiple DLQ Messages',
  DELETE_MULTIPLE_DLQ_MESSAGES_SUCCESS = '[DLQ] Delete Multiple DLQ Messages Success',
  DELETE_MULTIPLE_DLQ_MESSAGES_FAILURE = '[DLQ] Delete Multiple DLQ Messages Failure'
}

export class FetchDlqMessages implements Action {
  public readonly type = DlqActionTypes.FETCH_DLQ_MESSAGES;
  constructor(public payload: {
    service?: string;
    queueName?: string;
    message?: string;
    archived?: boolean;
    pendingReview?: boolean;
    contractBeginDate?: Date;
    pageSize?: number,
    pageNumber? : number,
    sortDescriptors?: SortDescriptor[]
  }) {}
}

export class FetchDlqMessagesSuccess implements Action {
  public readonly type = DlqActionTypes.FETCH_DLQ_MESSAGES_SUCCESS;
  constructor(public payload: { messages?: Array<DlqMessageHeader>, totalMessageCount?: number}) {}
}

export class FetchDlqMessagesFailure implements Action {
  public readonly type = DlqActionTypes.FETCH_DLQ_MESSAGES_FAILURE;
  constructor(public payload: {error: Error}) {}
}

export class FetchDlqMessageById implements Action {
  public readonly type = DlqActionTypes.FETCH_DLQ_MESSAGE_BY_ID;
  constructor(public payload: { messageId: number }) {}
}

export class FetchDlqMessageByIdSuccess implements Action {
  public readonly type = DlqActionTypes.FETCH_DLQ_MESSAGE_BY_ID_SUCCESS;
  constructor(public payload: { message: DlqMessage }) {}
}

export class FetchDlqMessageByIdFailure implements Action {
  public readonly type = DlqActionTypes.FETCH_DLQ_MESSAGE_BY_ID_FAILURE;
  constructor(public payload: {error: Error}) {}
}

export class DeleteDlqMessageById implements Action {
  public readonly type = DlqActionTypes.DELETE_DLQ_MESSAGE_BY_ID;
  constructor(public payload: { messageId: number }) {}
}

export class DeleteDlqMessageByIdSuccess implements Action {
  public readonly type = DlqActionTypes.DELETE_DLQ_MESSAGE_BY_ID_SUCCESS;
  constructor(public payload: { messageId: number }) {}
}

export class DeleteDlqMessageByIdFailure implements Action {
  public readonly type = DlqActionTypes.DELETE_DLQ_MESSAGE_BY_ID_FAILURE;
  constructor(public payload: {error: Error}) {}
}

export class RedriveDlqMessage implements Action {
  public readonly type = DlqActionTypes.REDRIVE_DLQ_MESSAGE_BY_ID;
  constructor(public payload: { messageId: number }) {}
}

export class RedriveDlqMessageSuccess implements Action {
  public readonly type = DlqActionTypes.REDRIVE_DLQ_MESSAGE_BY_ID_SUCCESS;
  constructor(public payload: { message: DlqMessage }) {}
}

export class RedriveDlqMessageFailure implements Action {
  public readonly type = DlqActionTypes.REDRIVE_DLQ_MESSAGE_BY_ID_FAILURE;
  constructor(public payload: {error: Error}) {}
}

export class ApproveDlqMessage implements Action {
  public readonly type = DlqActionTypes.APPROVE_DLQ_MESSAGE;
  constructor(public payload: { messageId: number, request: ApproveMessageRequest }) {}
}

export class ApproveDlqMessageSuccess implements Action {
  public readonly type = DlqActionTypes.APPROVE_DLQ_MESSAGE_SUCCESS;
  constructor(public payload: { messageId: number }) {}
}

export class ApproveDlqMessageFailure implements Action {
  public readonly type = DlqActionTypes.APPROVE_DLQ_MESSAGE_FAILURE;
  constructor(public payload: {error: Error}) {}
}

export class SubmitNewDlqMessage implements Action {
  public readonly type = DlqActionTypes.SUBMIT_NEW_DLQ_MESSAGE;
  constructor(public payload: { request: SubmitNewMessageRequest }) {}
}

export class SubmitNewDlqMessageSuccess implements Action {
  public readonly type = DlqActionTypes.SUBMIT_NEW_DLQ_MESSAGE_SUCCESS;
  constructor() {}
}

export class SubmitNewDlqMessageFailure implements Action {
  public readonly type = DlqActionTypes.SUBMIT_NEW_DLQ_MESSAGE_FAILURE;
  constructor(public payload: {error: Error}) {}
}

export class SubmitMessageForReview implements Action {
  public readonly type = DlqActionTypes.SUBMIT_MESSAGE_FOR_REVIEW;
  constructor(public payload: { messageId: number, request: MessageOverride }) {}
}

export class SubmitMessageForReviewSuccess implements Action {
  public readonly type = DlqActionTypes.SUBMIT_MESSAGE_FOR_REVIEW_SUCCESS;
  constructor() {}
}

export class SubmitMessageForReviewFailure implements Action {
  public readonly type = DlqActionTypes.SUBMIT_MESSAGE_FOR_REVIEW_FAILURE;
  constructor(public payload: {error: Error}) {}
}

export class DeleteMultipleDlqMessages implements Action {
  public readonly type = DlqActionTypes.DELETE_MULTIPLE_DLQ_MESSAGES;
  constructor(public payload: { messageIds: number[] }) {}
}

export class DeleteMultipleDlqMessagesSuccess implements Action {
  public readonly type = DlqActionTypes.DELETE_MULTIPLE_DLQ_MESSAGES_SUCCESS;
  constructor(public payload: { messageIds: number[] }) {}
}

export class DeleteMultipleDlqMessagesFailure implements Action {
  public readonly type = DlqActionTypes.DELETE_MULTIPLE_DLQ_MESSAGES_FAILURE;
  constructor(public payload: {error: Error}) {}
}

export type DlqActions =
  | FetchDlqMessages
  | FetchDlqMessagesSuccess
  | FetchDlqMessagesFailure
  | FetchDlqMessageById
  | FetchDlqMessageByIdSuccess
  | FetchDlqMessageByIdFailure
  | DeleteDlqMessageById
  | DeleteDlqMessageByIdSuccess
  | DeleteDlqMessageByIdFailure
  | RedriveDlqMessage
  | RedriveDlqMessageSuccess
  | RedriveDlqMessageFailure
  | ApproveDlqMessage
  | ApproveDlqMessageSuccess
  | ApproveDlqMessageFailure
  | SubmitNewDlqMessage
  | SubmitNewDlqMessageSuccess
  | SubmitNewDlqMessageFailure
  | SubmitMessageForReview
  | SubmitMessageForReviewSuccess
  | SubmitMessageForReviewFailure
  | DeleteMultipleDlqMessages
  | DeleteMultipleDlqMessagesSuccess
  | DeleteMultipleDlqMessagesFailure;
